<template>
  <div v-if="!solvedProblemsPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <div v-else class="h-full">
    <VueApexCharts
      height="100%"
      :options="solvedProblemsPresenter.chartOptions.value"
      :series="solvedProblemsPresenter.chartSeries.value"
      type="area"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, solvedProblemsChartColor } from '@/domain/value_objects/color/ColorList'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useSolvedProblemsPresenter } from '@/presentation/composables/dashboard/useSolvedProblemsPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const solvedProblemsPresenter = useSolvedProblemsPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      solvedProblemsPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        solvedProblemsChartColor,
        dashboardTargetColor,
        displayLanguage.value,
        isLightMode()
      )
    }

    return {
      initChart,
      solvedProblemsPresenter
    }
  }
})
</script>

<style lang="postcss" scoped>
.click-effect:active {
  @apply border-gray-900 bg-gray-200;
}

.click-effect-dark:active {
  @apply bg-dark-100;
}
</style>
